import { Pipe, PipeTransform } from '@angular/core';
import {
  filterLabelsById,
  filterLabelsByTranslationKey,
} from '@epicuro-next/constants/features/localization';
import { FiltersTranslationsKeys } from '@epicuro-next/models/product-filters';
import { Filter } from 'graphql-api/gql-api-interfaces';
@Pipe({
  name: 'filterDisplayName',
  standalone: true,
})
export class FilterDisplayNamePipe implements PipeTransform {
  public transform = filterDisplayNameTransform;
}

const getLabelByTranslationKey = (
  translationKey?: FiltersTranslationsKeys,
): string | undefined =>
  translationKey && filterLabelsByTranslationKey[translationKey];

export function filterDisplayNameTransform<
  T extends Pick<Filter, 'translationKey' | 'fieldId' | 'displayName'>,
>(filter: T, defaultValue?: string): string {
  return (
    getLabelByTranslationKey(
      filter.translationKey as FiltersTranslationsKeys,
    ) ||
    filterLabelsById[filter.fieldId] ||
    defaultValue ||
    filter.displayName
  );
}
